enum LengthOfStay {
  LESS_THAN_A_YEAR = 'LESS_THAN_A_YEAR',
  ONE_TO_THREE_YEARS = 'ONE_TO_THREE_YEARS',
  MORE_THAN_THREE_YEARS = 'MORE_THAN_THREE_YEARS',
}

export default LengthOfStay;
